/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.GoogleMap";
        class ComponentGoogleMap extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, config) {
                super(core, container, parent);
                this._config = null;
                this._map = null;
                this._readyToPlot = false;
                this._jsLoadErrorHandler = (peth, message) => {
                    this._log.info("ComponentGoogleMap._jsLoadErrorHandler()");
                    console.error("Unable to load Google Maps API script.");
                };
                this._jsLoaded = () => {
                    this._log.info("ComponentGoogleMap._jsLoaded()");
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                };
                this._present = () => {
                    this._log.info("ComponentGoogleMap._present()");
                    this._readyToPlot = true;
                    if (this._currentRequest)
                        this.drawMap(this._currentRequest);
                };
                this.drawMap = (pins) => {
                    this._log.info("ComponentGoogleMap.drawMap()");
                    this._currentRequest = pins;
                    if (!this._readyToPlot)
                        return;
                    if (!pins || (pins.length == 0))
                        return;
                    this._map = new google.maps.Map(this._container, { mapTypeId: google.maps.MapTypeId.ROADMAP });
                    let infowindow = new google.maps.InfoWindow();
                    // Place pins in one iteration, then zoom after
                    pins.forEach(pin => {
                        // Generate the lat/long
                        pin.Coordinate = new google.maps.LatLng(pin.Latitude, pin.Longitude);
                        // Stick the pin in the map
                        let marker = new google.maps.Marker({ position: pin.Coordinate, map: this._map });
                        // Add info box with location info
                        google.maps.event.addListener(marker, 'click', (function (marker) {
                            return function () {
                                infowindow.setContent(pin.Label);
                                infowindow.open(this._map, marker);
                            };
                        })(marker));
                    });
                    // Zoom to bounds described by pins
                    let bounds = new google.maps.LatLngBounds();
                    pins.forEach(pin => {
                        bounds.extend(pin.Coordinate);
                    });
                    this._map.fitBounds(bounds, 5);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentGoogleMap::constructor");
                this._config = config;
                if (config.hasOwnProperty('ApiKey') && config.ApiKey) {
                    let url = `https://maps.googleapis.com/maps/api/js?key=${config.ApiKey}`;
                    this._core.Loader.loadUnversionedJS(url, this._jsLoaded, this._jsLoadErrorHandler);
                }
                else
                    console.error("No API key supplied for Google Maps integration.");
            }
        }
        Widgets.ComponentGoogleMap = ComponentGoogleMap;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
